import React, { useContext, useState } from "react";
import { ThemeContext } from "../../ThemedContext/Provider";
import FrontPage from "../../components/FrontPage";
import Trending from "../../components/Trending";

import TopSongs from "../../components/TopSongs";
import FeatureArtists from "../../components/FeatureArtists";
import FirstAdvert from "../../components/FirstAdvert";

import Blogs from "../../components/Blog";

import { AppStyle, Div } from "./style";

function Dashboard() {
  const { theme } = useContext(ThemeContext);
  const [scroll, setScroll] = useState("");

  document.onscroll = () => {
    if (window.scrollY > 360) {
      setScroll("scroll");
    } else {
      setScroll("");
    }
  };
  return (
    <AppStyle themed={theme}>
      <FrontPage />
      <Trending />
      <Div>
        <TopSongs />
        <FeatureArtists />
      </Div>
      <FirstAdvert />

      <Blogs />
      <span
        className={`arrows ${scroll}`}
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        ⮝
      </span>
    </AppStyle>
  );
}

export default Dashboard;
